import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Select from "react-select";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AlertModal from "../_common/AlertModal";
import pendingIssueActions from "../../_actions/pendingIssueActions";

class AddPendingIssueModalV3 extends Component {
  state = {
    formData: {
      pendingIssueId: 0,
      projectId: null,
      pendingIssueNo: "",
      title: "",
      description: "",
      rfiId: "",
      selectedPiLocations: [],
      locationIds: [],
      createdByUserId: null,
    },
    formErrors: {},
    showAlert_fetchError: false,
    showAlert_saveError: false,
    errorOnFetch: null,
    errorOnSubmit: null,
  };

  componentDidMount() {
    const { projectId, user, dispatch } = this.props;
    dispatch(pendingIssueActions.getNextPendingIssueNo(projectId))
      .then((pendingIssueNo) =>
        this.setState({
          formData: {
            ...this.state.formData,
            projectId,
            pendingIssueNo,
            createdByUserId: user.userId,
          },
        })
      )
      .catch((errorOnFetch) => {
        this.setState({ errorOnFetch });
        this.toggleAlert_fetchError();
      });
  }

  formIsIncomplete = () => {
    const { formData } = this.state;
    const { title, description } = this.state.formErrors;
    return title || description || !formData.title || !formData.description;
  };

  handleBlur = (e) => this.validateForm(e.target.name);

  validateForm = (fieldName) => {
    const { formData } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (fieldName) {
      case "title":
        if (!formData.title) formErrors.title = "Required";
        else formErrors.title = null;
        break;
      case "description":
        if (!formData.description) formErrors.description = "Required";
        else formErrors.description = null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  handleSubmit_addPi = (e) => {
    e.preventDefault();
    const { dispatch, toggleModal_addPi, projectId } = this.props;
    const piData = { ...this.state.formData };
    if (!this.formIsIncomplete()) {
      piData.locationIds =
        piData.selectedPiLocations.length > 0
          ? piData.selectedPiLocations.map((pil) => pil.value)
          : [];

      dispatch(pendingIssueActions.add(piData));
      dispatch(pendingIssueActions.getAll(projectId));
      toggleModal_addPi();
    }
  };

  handleChange = (e) =>
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });

  handleChange_piLocations = (selectedPiLocations) =>
    this.setState({
      formData: {
        ...this.state.formData,
        selectedPiLocations,
      },
    });

  toggleAlert_saveError = () =>
    this.setState({ showAlert_saveError: !this.state.showAlert_saveError });
  toggleAlert_fetchError = () =>
    this.setState({ showAlert_fetchError: !this.state.showAlert_fetchError });

  render() {
    const { showModal_addPi, toggleModal_addPi, projLocationList } = this.props;
    const {
      formData,
      formErrors,
      showAlert_fetchError,
      showAlert_saveError,
      errorOnFetch,
      errorOnSubmit,
    } = this.state;

    const closeBtn = (
      <button className="close" onClick={toggleModal_addPi}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );

    return (
      <React.Fragment>
        <Modal
          isOpen={showModal_addPi}
          toggle={toggleModal_addPi}
          className={this.props.className}
          fade={false}
          size="ml"
        >
          <ModalHeader
            toggle={toggleModal_addPi}
            className="bg-info text-white"
            close={closeBtn}
          >
            <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
            Add New Pending Issue
          </ModalHeader>
          <ModalBody>
            <form
              id="addPendingIssueForm"
              onSubmit={this.handleSubmit_addPi}
              autoComplete={"off"}
            >
              <div className="card">
                <div className="card-body">
                  <div className="form-row form-group mb-2">
                    <label className="col-sm-3 col-form-label my-auto">
                      <b>Issue No.:</b>
                    </label>
                    <div className="col-sm-3">
                      <input
                        id="pendingIssueNo"
                        name="pendingIssueNo"
                        className="form-control"
                        value={formData.pendingIssueNo}
                        onChange={this.handleChange}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="title" className="col-sm-3 col-form-label">
                      <b>Issue Title:</b>*
                    </label>
                    <div className="col-sm-9">
                      <input
                        id="title"
                        name="title"
                        className="form-control"
                        value={formData.title}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        maxLength="200"
                      />
                      {formErrors.title && (
                        <span className="error-small">
                          <small>{formErrors.title}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="rfiId" className="col-sm-3 col-form-label">
                      Related RFI:
                    </label>
                    <div className="col-sm-9">
                      <input
                        id="rfiId"
                        name="rfiId"
                        className="form-control"
                        value={formData.rfiId}
                        onChange={this.handleChange}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="description" className="col-sm-3 col-form-label">
                      <b>Description:</b>*
                    </label>
                    <div className="col-sm-9">
                      <textarea
                        id="description"
                        name="description"
                        className="form-control"
                        rows="2"
                        value={formData.description}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                    </div>
                  </div>
                  <div className="form-row form-group mb-0">
                    <label htmlFor="locations" className="col-sm-3 col-form-label">
                      <b>Location(s):</b>
                    </label>
                    <div className="col-sm-9">
                      <Select
                        name="pendingIssueLocations"
                        id="pendingIssueLocations"
                        value={formData.selectedPiLocations}
                        options={(projLocationList || []).map((l) => ({
                          value: l.locationId,
                          label: l.name,
                        }))}
                        onChange={this.handleChange_piLocations}
                        placeholder="(Select location(s) affected by this issue)"
                        isMulti
                        isClearable
                        isSearchable
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <div className="form-row form-group">
              <input
                className="btn btn-primary"
                name="addPendingIssue"
                type="submit"
                form="addPendingIssueForm"
                onClick={this.handleSubmit_addPi}
                value="Add"
                disabled={this.formIsIncomplete()}
              />{" "}
              <button
                className="btn btn-secondary ml-2"
                color="secondary"
                onClick={toggleModal_addPi}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </Modal>
        {showAlert_saveError && (
          <AlertModal
            alertTitle="Error"
            alertText={`There was an error while trying to save.\n${errorOnSubmit}\nPlease contact DMS administrator.`}
            acceptCaption="OK"
            acceptClass="danger"
            provideReject={false}
            handleAlertAction={this.toggleAlert_saveError}
            toggleAlertModal={this.toggleAlert_saveError}
            showAlertModal={showAlert_saveError}
          />
        )}
        {showAlert_fetchError && (
          <AlertModal
            alertTitle="Error"
            alertText={`There was an error while trying to save.\n${errorOnFetch}\nPlease contact DMS administrator.`}
            acceptCaption="OK"
            acceptClass="danger"
            provideReject={false}
            handleAlertAction={this.toggleAlert_fetchError}
            toggleAlertModal={this.toggleAlert_fetchError}
            showAlertModal={showAlert_fetchError}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  projLocationList: state.locations.projLocationLists[ownProps.projectId] || null,
  user: state.authentication.user,
});

export default connect(mapStateToProps)(AddPendingIssueModalV3);
